import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "新建下载任务", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "file-upload__placeholder" }, " 填写要下载的文件链接 ", -1)
const _hoisted_3 = { class: "file-upload__body" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "javascript:;",
  class: "qh-icon-add"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("添加本地BT文件 ")
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "textarea__tips"
}
const _hoisted_8 = {
  key: 0,
  class: "detect-compatibility"
}
const _hoisted_9 = { class: "file-upload__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownloadPath = _resolveComponent("DownloadPath")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["file-upload", { 'android-padding': _ctx.isAndroid, 'ios-padding': _ctx.isIOS }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["file-upload__header page-header", { 'sl-full': _ctx.isFullScreen }])
    }, [
      _createElementVNode("a", {
        href: "javascript:;",
        class: "qh-icon-back",
        title: "返回",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleOnBack && _ctx.handleOnBack(...args)))
      }),
      _createElementVNode("a", {
        href: "javascript:;",
        class: "icomoon-close",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleOnBack && _ctx.handleOnBack(...args)))
      }),
      _hoisted_1
    ], 2),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: _normalizeClass(["textarea", _ctx.error ? 'textarea__error' : ''])
      }, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputText) = $event)),
          class: "textarea__inner",
          ref: "textarea",
          placeholder: '支持HTTP、HTTPS、FTP、磁力链、电驴链接。换行可同时添加，最多可支持50条',
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.error = ''))
        }, null, 544), [
          [_vModelText, _ctx.inputText]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["textarea__upload", { disable: !_ctx.showUploadBT }]),
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleUploadBT && _ctx.handleUploadBT(...args)))
        }, _hoisted_6, 2),
        _createElementVNode("input", {
          id: "upload",
          ref: "uploadInput",
          class: "textarea__input",
          type: "file",
          accept: ".torrent",
          multiple: "",
          onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleOnSelecteBTFiles && _ctx.handleOnSelecteBTFiles(...args)))
        }, null, 544),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (!_ctx.isSupportBEncode)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, " 检测到浏览器版本过低，添加本地BT文件功能可能无法正常使用 "))
      : _createCommentVNode("", true),
    _createVNode(_component_DownloadPath, {
      class: _normalizeClass(_ctx.visibleDownloadPath ? '' : 'file-upload__download-path-hide'),
      "hide-size": ""
    }, null, 8, ["class"]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("a", {
        class: _normalizeClass(["file-upload__button file-upload__button-ok", { disabled: _ctx.inputText.length < 5 }]),
        href: "javascript:;",
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleOnSubmitLinks && _ctx.handleOnSubmitLinks(...args)))
      }, "立即下载", 2),
      _createElementVNode("a", {
        href: "javascript:;",
        class: "file-upload__button-cance",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleOnBack && _ctx.handleOnBack(...args)))
      }, "取消")
    ])
  ], 2))
}